<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="col-12 lg:col-12 md:col-12">
      <div class="p-fluid p-formgrid grid">
        <div class="p-field col-12 md:col-6">
          <span class="p-float-label size_cent">
            <input formControlName="name" class="p-inputtext size_cent" pInputText type="text" autoFocus />
            <label>{{'DisName' | translate}} *</label>
          </span>
          @if (isAdmin === true) {
            <span class="p-float-label size_cent form-margin">
              <div>{{'Visibility' | translate}} *</div>
              <p-dropdown
                formControlName="visibility"
                [options]="listVisibility"
                (onChange)="onChangeVisibility($event)"
                placeholder="{{'Sel_TyDisp' | translate}}"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </span>
          }
        </div>
        <div class="p-field col-12 md:col-6">
          <div>{{'Desc' | translate}}</div>
          <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
          <div class="col-12 grid">
            <div class="col-3"></div>
            @if (isBskReq === 'mail') {
              <div class="col-6 badge grey">{{'Display_5_Dis' | translate}}</div>
            }
            @if (isBskReq === 'bsk') {
              <div class="col-6 badge grey">{{'Display_6_Dis' | translate}}</div>
            }
          </div>          
        </div>
      </div>
    </div>
    <div class="p-fluid p-formgrid grid">
      @if (visibility === 1) {
        <div class="col-4">
          <div class="center-text">{{'List_Grp' | translate}}</div>
          <p-listbox
            formControlName="groupListUsed"
            [options]="groupList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '35vh' }"
            scrollHeight="35vh"
            >
          </p-listbox>
        </div>
      }
      @if (visibility === 2 && isAdmin === true) {
        <div class="col-4">
          <div class="center-text">{{'List_Usr' | translate}}</div>
          <p-listbox
            formControlName="userListUsed"
            [options]="userList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '35vh' }"
            scrollHeight="35vh"
            >
          </p-listbox>
        </div>
      }
      <div [ngClass]="(visibility === 1 || visibility === 2) && isAdmin ? 'lg:col-4' : 'lg:col-6'" class="col-12">
        <div class="grid">
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              formControlName="filterType"
              name="filterType"
              value="idx"
              (onClick)="onFilterClick('idx')"
              inputId="opt1"
            ></p-radioButton>
            <label for="opt1" class="ml-2">{{'Index_B' | translate}}</label>
          </div>
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              formControlName="filterType"
              name="filterType"
              value="doc"
              (onClick)="onFilterClick('doc')"
              inputId="opt2"
            ></p-radioButton>
            <label for="opt2" class="ml-2">{{'Proper' | translate}}</label>
          </div>
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              formControlName="filterType"
              name="filterType"
              value="bsk"
              (onClick)="onFilterClick('bsk')"
              inputId="opt3"
            ></p-radioButton>
            <label for="opt3" class="ml-2">{{'ProperBsk' | translate}}</label>
          </div>

          <div class="p-field-radiobutton col-3">
            <p-radioButton
              formControlName="filterType"
              name="filterType"
              value="sys"
              (onClick)="onFilterClick('sys')"
              inputId="opt3"
            ></p-radioButton>
            <label for="opt3" class="ml-2">{{'System' | translate}}</label>
          </div>
        </div>
        <div class="scroll-table">
          <p-table
            #dt
            selectionMode="single"
            [columns]="listColumns"
            [value]="currentList"
            [paginator]="false"
            responsiveLayout="stack"
            [breakpoint]="'960px'"
            (onRowSelect)="moveToTarget($event)"
            [sortField]="'name'"
            >
            <ng-template let-columns pTemplate="header">
              <tr>
                @for (col of columns; track col; let i = $index) {
                  <th
                    [pSortableColumn]="col.field"
                    class="width-auto"
                    >
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                    {{ col.header }}
                    <input
                      (click)="$event.stopPropagation()"
                      pInputText
                      type="text"
                      (input)="dt.filter($event.target.value, col.field, 'contains')"
                      style="color: darkgrey"
                      />
                    </th>
                  }
                </tr>
              </ng-template>
              <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
                <tr [pSelectableRow]="rowData">
                  @for (col of columns; track col; let i = $index) {
                    <td class="width-auto">
                      <div>{{ rowData[col.field] }}
                        @if (i === 0) {
                          <span>( {{rowData['Type']}} )</span>
                        }
                      </div>
                    </td>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">{{'Empty' | translate}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div [ngClass]="(visibility === 1 || visibility === 2) && isAdmin ? 'lg:col-4' : 'lg:col-6'" class="col-12">
          <div class="scroll-table center-text">{{'List_Idx' | translate}}
            <p-table [value]="indexResultList">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th style="width:2em"></th>
                  <th style="width:auto"></th>
                  <th style="width:10em"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData  let-index="rowIndex">
                <tr [pReorderableRow]="index">
                  <td>
                    <i class="pi pi-bars" pReorderableRowHandle></i>
                  </td>
                  <td class="word-break-all">
                    {{ rowData.Label }} ({{ rowData.Name }})
                  </td>
                  <td style="text-align: right;">
                    <!-- <i *ngIf="index.NumOrder==-1" class="fa ui-icon-close margin-right iconstyle" (click)="changeOrder(idx)"></i>
                    <i *ngIf="rowData.NumOrder>=0 && rowData.TypeOrder===0" class="icons8-down-arrow-2 margin-right iconstyle" (click)="changeOrder(idx)"></i>
                    <i *ngIf="rowData.NumOrder>=0 && rowData.TypeOrder===1" class="icons8-up-2 margin-right iconstyle" (click)="changeOrder(idx)"></i> -->
                    @if (rowData.ThumbInfo === 1 || rowData.ThumbInfo === true) {
                      <i
                        class="icons8-eye margin-right iconstyle_auto"
                      ></i>
                    }
                    @if (rowData.NumOrder >= 0 && rowData.TypeOrder == 0) {
                      <i class="icons8-alphabetical-sorting margin-right iconstyle_auto"
                      ></i>
                      ({{ rowData.NumOrder }})
                    }
                    @if (rowData.NumOrder >= 0 && rowData.TypeOrder == 1) {
                      <i class="icons8-alphabetical-sorting-2 margin-right iconstyle_auto"
                      ></i>
                      ({{ rowData.NumOrder }})
                    }
                    <i class="pi pi-pencil" (click)="updateIndex(rowData)" style="cursor: pointer"></i>
                    <i class="icons8-trash-can iconstyle" (click)="deleteIndex(rowData)" style="color: red"></i>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="foo-ter col-12 lg:col-12 md:col-12 align-right">
    @if (resultForm.controls['id'].value) {
      <button
        (click)="deleteItem()"
        class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
        >
        {{'Delete' | translate}}
      </button>
    }
    @if (resultForm.controls['id'].value) {
      <button
        (click)="validate(true)"
        type="button"
        class="p-button p-component p-button-text-only btn-square margin"
        >
        {{'Duplic' | translate}}
      </button>
    }
    <button
      (click)="cancel()"
      type="button"
      class="p-button p-button-primary p-button-outlined p-component p-button-text-only btn-square margin"
      >
      {{'Cancel' | translate}}
    </button>
    <button
      (click)="validate(false)"
      type="button"
      class="p-button p-component p-button-text-only btn-square margin"
      >
      {{'Valid' | translate}}
    </button>
  </div>

  @if (displayDet === true) {
      <resdetindex
        [visible]="displayDet"
        [indexData]="selectedItem"
        (onValid)="validItem($event)"
        (onClose)="closeCriteria()"
        >
      </resdetindex>
  }
